var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"dark":""}},[_c('v-list-item-group',_vm._l((_vm.items),function(item,index){return _c('v-list-item',{key:index},[_c('v-list-item-content',{staticClass:"min-width-100"},[_c('v-list-item-title',{on:{"click":function($event){return _vm.handleSelect(item.action)}}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }